import { render, staticRenderFns } from "./RequestAddRoadsLabels.vue?vue&type=template&id=2cf61390&"
import script from "./RequestAddRoadsLabels.vue?vue&type=script&lang=js&"
export * from "./RequestAddRoadsLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QItem,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QItem,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
